import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  item: null,
  itemData: null,
  tree: [],
  nesting: 0,
  created: null,
  successfulMsg: null,
  failedMsg: null,
  pdf: null
}

// getters
export const getters = {
  item: state => state.item,
  itemData: state => state.itemData,
  tree: state => state.tree,
  nesting: state => state.nesting,
  created: state => state.created,
  successfulMsg: state => state.successfulMsg,
  failedMsg: state => state.failedMsg,
  pdf: state => state.pdf
}

// mutations
export const mutations = {
  SWITCH_BOM (state, data) {
    state.item = data
  },
  SWITCH_CREATED (state, data) {
    state.created = data
  },
  SWITCH_ITEM_DATA (state, data) {
    state.itemData = data
  },
  SWITCH_NESTING (state, data) {
    state.nesting = data
  },
  SUCCESSFUL_MESSAGE (state, data) {
    state.successfulMsg = data
  },
  FAILED_MESSAGE (state, data) {
    state.failedMsg = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

// actions
export const actions = {
  async fetchBomTree ({ commit }, filterData) {
    if (filterData.item_id) {
      const { data } = await axios.get(laroute.route('bom_list', {
        companyAbbr: this.getters['auth/company'],
        ...filterData
      }))
      commit('SWITCH_BOM', data.item)
      commit('SWITCH_NESTING', data.nesting || 0)
      commit('SWITCH_ITEM_DATA', data.item_data)
      commit('SWITCH_CREATED', !(data.item === null))
    } else {
      commit('SWITCH_BOM', null)
      commit('SWITCH_NESTING', 0)
      commit('SWITCH_ITEM_DATA', null)
      commit('SWITCH_CREATED', null)
    }
  },

  async addNewBom ({ commit }, bomData) {
    const { data } = await axios.put(laroute.route('bom_create', bomData))

    commit('SWITCH_BOM', data.item)
    commit('SWITCH_CREATED', !(data.item === null))
  },

  async copyBomItem ({ commit }, bomData) {
    try {
      await axios.post(laroute.route('bom_copy', bomData))
    } catch (e) {
      commit('FAILED_MESSAGE', e.response.data.error)
    }

    commit('SUCCESSFUL_MESSAGE', 'Item successfully copied.')
  },

  async getPdf ({ commit }, { params, options }) {
    const { data } = await axios.post(laroute.route('bom_pdf', { companyAbbr: store.getters['auth/company'] }), { params, options }, { responseType: 'arraybuffer' })
    commit('PDF', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/bom.js